var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 57C44.2401 57 57 44.2401 57 28.5C57 12.7599 44.2401 0 28.5 0C12.7599 0 0 12.7599 0 28.5C0 44.2401 12.7599 57 28.5 57Z",
    fill: "#038654"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5143 14.7402H18.4849C15.7308 14.7402 13.4775 16.9935 13.4775 19.7475V32.2659C13.4775 35.0199 15.7308 37.2734 18.4849 37.2734V41.029C18.4849 42.1557 19.8619 42.6561 20.613 41.905L25.2448 37.2734H38.5143C41.2683 37.2734 43.5216 35.0199 43.5216 32.2659V19.7475C43.5216 16.9935 41.2683 14.7402 38.5143 14.7402ZM31.0032 29.7622H23.4922C22.7411 29.7622 22.2404 29.2616 22.2404 28.5105C22.2404 27.7594 22.7411 27.2585 23.4922 27.2585H31.0032C31.7543 27.2585 32.2551 27.7594 32.2551 28.5105C32.2551 29.2616 31.7543 29.7622 31.0032 29.7622ZM33.5069 24.7549H23.4922C22.7411 24.7549 22.2404 24.2542 22.2404 23.5031C22.2404 22.752 22.7411 22.2512 23.4922 22.2512H33.5069C34.258 22.2512 34.7587 22.752 34.7587 23.5031C34.7587 24.2542 34.258 24.7549 33.5069 24.7549Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalReviews);
export default __webpack_public_path__ + "static/media/total-reviews.a0e08d4265de1b46520ec264eb94fbea.svg";
export { ForwardRef as ReactComponent };